import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { KioskProvider } from './context/KioskContext';
import { LanguageProvider } from './context/LanguageContext';
import { CartProvider } from './context/CartContext';
import { RentalProvider } from './context/RentalContext';
import { AdminProvider } from './context/AdminContext';
// Temporarily hidden (Google flagged catalog/rental funnel as compromised — kept for restore, see routes below):
// import MainPage from './pages/MainPage';
// import ToolPage from './pages/ToolPage';
// import CartPage from './pages/CartPage';
// import PaymentResultPage from './pages/PaymentResultPage';
// import VerificationPage from './pages/VerificationPage';
// import MobileCheckoutPage from './pages/MobileCheckoutPage';
// import CartBar from './components/CartBar';
import HowItWorksPage from './pages/HowItWorksPage';
import AboutPage from './pages/AboutPage';
import BusinessPage from './pages/BusinessPage';
import TermsPage from './pages/TermsPage';
import SafetyPage from './pages/SafetyPage';
import PrivacyPage from './pages/PrivacyPage';
import AgreementPage from './pages/AgreementPage';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollManager from './components/ScrollManager';
import LanguageRouteSync from './components/LanguageRouteSync';
import AdminLayout from './pages/admin/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import AdminMachines from './pages/admin/AdminMachines';
import AdminMachineForm from './pages/admin/AdminMachineForm';
import AdminTools from './pages/admin/AdminTools';
import AdminToolForm from './pages/admin/AdminToolForm';
import AdminOrders from './pages/admin/AdminOrders';
import NotFoundPage from './pages/NotFoundPage';
import RentPage from './pages/RentPage';
import ToolLandingPage from './pages/ToolLandingPage';

function App() {
  return (
    <KioskProvider>
      <LanguageProvider>
        <RentalProvider>
        <CartProvider>
        <AdminProvider>
          <Router>
            <div className="bg-white">
              <ErrorBoundary>
              <Routes>
                {/* Temporarily hidden — catalog/rental funnel flagged by Google as compromised.
                    Falls through to the "*" NotFoundPage route below. To restore, uncomment
                    these routes and their imports above. */}
                {/* <Route path="/catalog" element={<MainPage />} /> */}
                {/* <Route path="/tool/:vendingMachineId/:toolId" element={<ToolPage />} /> */}
                {/* <Route path="/cart" element={<CartPage />} /> */}
                {/* <Route path="/checkout/verify" element={<VerificationPage />} /> */}
                {/* <Route path="/payment/result" element={<PaymentResultPage />} /> */}
                {/* <Route path="/m/:token" element={<MobileCheckoutPage />} /> */}
                <Route path="/rent/:slug" element={<ToolLandingPage />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/business" element={<BusinessPage />} />
                {/* Russian versions of the public SEO pages — see src/utils/langPath.js */}
                <Route path="/ru" element={<RentPage />} />
                <Route path="/ru/rent/:slug" element={<ToolLandingPage />} />
                <Route path="/ru/how-it-works" element={<HowItWorksPage />} />
                <Route path="/ru/about" element={<AboutPage />} />
                <Route path="/ru/business" element={<BusinessPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/safety" element={<SafetyPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/agreement" element={<AgreementPage />} />
                {/* Admin routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminMachines />} />
                  <Route path="machines/new" element={<AdminMachineForm />} />
                  <Route path="machines/:machineId/edit" element={<AdminMachineForm />} />
                  <Route path="machines/:machineId/tools" element={<AdminTools />} />
                  <Route path="machines/:machineId/tools/new" element={<AdminToolForm />} />
                  <Route path="machines/:machineId/tools/:toolId/edit" element={<AdminToolForm />} />
                  <Route path="orders" element={<AdminOrders />} />
                </Route>
                <Route path="/" element={<RentPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              </ErrorBoundary>
              <ScrollManager />
              <LanguageRouteSync />
              {/* <CartBar /> — hidden along with the cart/checkout funnel above */}
            </div>
          </Router>
        </AdminProvider>
        </CartProvider>
        </RentalProvider>
      </LanguageProvider>
    </KioskProvider>
  );
}

export default App;
